import { Display } from '@/components/Display/Display';
import { useEffect } from 'react';
import { Tooltip } from 'antd';
import './guide.scss';
const defaultImg = require('@/assets/images/web/guideConfig/11.webp');
const ToolTipContent = ({ title, des }) => {
    return (
        <>
            <div>{title}</div>
            <div>{des}</div>
        </>
    );
};
const GuideToolTip = ({ title, des }) => {
    return (
        <Tooltip placement="bottomLeft" title={<ToolTipContent title={title} des={des} />}>
            <div className={['title']}>{title}</div>
            <div className={['sub-title']}>{des}</div>
        </Tooltip>
    );
};

const LinkGuide = (props) => {
    const { data = [], clickGuideS } = props;
    const getStyle = () => {
        let doms = document.querySelectorAll('.guide-item-wrap');
        if (doms.length) {
            doms.forEach((dom) => {
                let bgName = dom.getAttribute('data-bg');
                let img = require(`@/assets/images/web/guideConfig/${bgName}.webp`) || defaultImg;

                dom.style.backgroundImage = `url(${img})`;
            });
        }
    };

    useEffect(() => {
        getStyle();
    }, [data]);
    const onClickItem = (item) => {
        console.log('item==========', item);
        if (props.onClick) {
            props.onClick(item);
        }
    };

    return (
        <>
            <div className={['box-wrap']}>
                <div className={['show-box']}>
                    <Display show={data.length === 1}>
                        <div
                            onClick={() => {
                                onClickItem(data[0]);
                            }}
                            data-type={1}
                            data-bg={11}
                            className={['guide-item-wrap']}
                        >
                            <GuideToolTip title={data[0]?.name} des={data[0]?.custom_content}></GuideToolTip>
                        </div>
                    </Display>
                    <Display show={data.length === 2}>
                        {data.map((ele, index) => {
                            return (
                                <div
                                    onClick={() => {
                                        onClickItem(ele);
                                    }}
                                    data-type={2}
                                    key={index + 1}
                                    data-bg={`2${index + 1}`}
                                    className={['guide-item-wrap']}
                                >
                                    <GuideToolTip title={ele?.name} des={ele?.custom_content}></GuideToolTip>
                                </div>
                            );
                        })}
                    </Display>
                    <Display show={data.length === 3}>
                        <div className={['left']}>
                            <div
                                onClick={() => {
                                    onClickItem(data[0]);
                                }}
                                data-type={3}
                                data-bg={31}
                                className={['guide-item-wrap']}
                            >
                                <GuideToolTip title={data[0]?.name} des={data[0]?.custom_content}></GuideToolTip>
                            </div>
                        </div>
                        <div className={['right']}>
                            {data.slice(1).map((ele, index) => {
                                return (
                                    <div
                                        onClick={() => {
                                            onClickItem(ele);
                                        }}
                                        data-type={3}
                                        data-bg={`3${index + 2}`}
                                        key={index}
                                        className={['guide-item-wrap']}
                                    >
                                        <GuideToolTip title={ele?.name} des={ele?.custom_content}></GuideToolTip>
                                    </div>
                                );
                            })}
                        </div>
                    </Display>
                    <Display show={data.length === 4}>
                        {data.map((ele, index) => {
                            return (
                                <div
                                    onClick={() => {
                                        onClickItem(ele);
                                    }}
                                    data-type={4}
                                    key={index + 1}
                                    data-bg={`4${index + 1}`}
                                    className={['guide-item-wrap']}
                                >
                                    <GuideToolTip title={ele?.name} des={ele?.custom_content}></GuideToolTip>
                                </div>
                            );
                        })}
                    </Display>
                    <Display show={data.length === 5}>
                        <div className={['left-5']}>
                            <div
                                onClick={() => {
                                    onClickItem(data[0]);
                                }}
                                data-type={5}
                                data-bg={51}
                                className={['guide-item-wrap']}
                            >
                                <GuideToolTip title={data[0]?.name} des={data[0]?.custom_content}></GuideToolTip>
                            </div>
                        </div>
                        <div className={['right-5']}>
                            {data.slice(1).map((ele, index) => {
                                return (
                                    <div
                                        onClick={() => {
                                            onClickItem(ele);
                                        }}
                                        data-type={5}
                                        data-bg={`5${index + 2}`}
                                        key={index}
                                        className={['guide-item-wrap']}
                                    >
                                        <GuideToolTip title={ele?.name} des={ele?.custom_content}></GuideToolTip>
                                    </div>
                                );
                            })}
                        </div>
                    </Display>
                </div>
            </div>
        </>
    );
};

export default LinkGuide;
